import { useCallback } from 'react';
import { useAuthentication } from '@johnlewispartnership/wtr-website-authentication/dist/context';
import { useAnalytics } from '@johnlewispartnership/wtr-website-analytics';

import config from 'config';
import locator from 'locator';
import shoppingContextService from 'services/shoppingContext';
import { CustomerOrderState } from 'services/shoppingContext/types';

export type PurchaseOrAmendType = 'purchase' | 'amend';

const getPurchaseOrAmend = async (authHeader?: string): Promise<PurchaseOrAmendType> => {
  if (!authHeader) return 'purchase';

  try {
    const shoppingContext = await shoppingContextService.getShoppingContext(authHeader);

    return shoppingContext.customerOrderState === CustomerOrderState.AMENDING
      ? 'amend'
      : 'purchase';
  } catch {
    return 'purchase';
  }
};

export const useTrackVirtualPageView = () => {
  const { state } = useAuthentication();
  const { initialised, token, isLoggedIn } = state;
  const { trackVirtualPageView } = useAnalytics();

  return useCallback(async () => {
    if (!initialised) return;

    const purchaseOrAmend = await getPurchaseOrAmend(token?.authHeader);

    trackVirtualPageView({
      authenticated: isLoggedIn,
      // TODO(WPIP-81779): refactor `location` usage to use `locator`.
      location: window.location.href,
      path: locator.pathname,
      previous_path: document.referrer,
      service_name: config.applicationName,
      title: document.title,
      purchase_or_amend: purchaseOrAmend,
      // TODO(WPIP-78874): Implement server-side type identifier that can be passed down e.g within preloadedData.
      type: locator.pathname.startsWith('/ecom/recipes') ? 'recipes' : 'cms',
    });
  }, [initialised, isLoggedIn, token, trackVirtualPageView]);
};
